{
  "metadata": {
    "id": "solarized-dark",
    "name": "Solarized",
    "description": "Портировано из темы «Solarized» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "solarized.json",
      "project": "altercation",
      "url": "https://github.com/altercation/solarized",
      "upstreamFile": "packages/ui/src/theme/themes/solarized.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.9,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.419,
      "paletteMaxS": 0.485,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 29.9,
      "syntaxVsTextMinDeltaE": 4.3,
      "chartsMinDeltaE": 30.4,
      "textSeparationDeltaE": 10.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#6c71c4",
      "hover": "#7e82cb",
      "active": "#898dd0",
      "foreground": "#000000",
      "muted": "#6c71c480",
      "emphasis": "#6c71c4"
    },
    "surface": {
      "background": "#002b36",
      "foreground": "#c0c8c8",
      "muted": "#1a3d46",
      "mutedForeground": "#9eb1b4",
      "elevated": "#26464e",
      "elevatedForeground": "#a3afaf",
      "raised": "#425c63",
      "raisedForeground": "#cad0d0",
      "overlay": "#002b36cc",
      "subtle": "#0d343e"
    },
    "interactive": {
      "border": "#456066",
      "borderHover": "#294c54",
      "borderFocus": "#6c71c4",
      "selection": "#93a1a129",
      "selectionForeground": "#93a1a1",
      "focus": "#6c71c459",
      "focusRing": "#6c71c461",
      "cursor": "#93a1a1",
      "hover": "#93a1a11c",
      "active": "#93a1a129"
    },
    "status": {
      "error": "#e56663",
      "errorForeground": "#000000",
      "errorBackground": "#e5666324",
      "errorBorder": "#e5666373",
      "warning": "#b58900",
      "warningForeground": "#000000",
      "warningBackground": "#b5890024",
      "warningBorder": "#b5890073",
      "success": "#859900",
      "successForeground": "#000000",
      "successBackground": "#85990024",
      "successBorder": "#85990073",
      "info": "#2aa198",
      "infoForeground": "#000000",
      "infoBackground": "#2aa19824",
      "infoBorder": "#2aa19873"
    },
    "pr": {
      "open": "#859900",
      "draft": "#afbec1",
      "blocked": "#b58900",
      "merged": "#d33682",
      "closed": "#e56663"
    },
    "syntax": {
      "base": {
        "background": "#314f57",
        "foreground": "#93a1a1",
        "comment": "#aebdc2",
        "keyword": "#adc700",
        "string": "#44cec4",
        "number": "#eca7c8",
        "function": "#89c2ea",
        "variable": "#b4bdbd",
        "type": "#02ff43",
        "operator": "#f1f3f4"
      },
      "tokens": {
        "commentDoc": "#aebdc2",
        "stringEscape": "#f1f3f4",
        "keywordImport": "#adc700",
        "storageModifier": "#adc700",
        "functionCall": "#89c2ea",
        "method": "#89c2ea",
        "variableProperty": "#89c2ea",
        "variableOther": "#b4bdbd",
        "variableGlobal": "#eca7c8",
        "variableLocal": "#f1f3f4",
        "parameter": "#b4bdbd",
        "constant": "#eca7c8",
        "class": "#02ff43",
        "className": "#02ff43",
        "interface": "#02ff43",
        "struct": "#02ff43",
        "enum": "#02ff43",
        "typeParameter": "#02ff43",
        "namespace": "#02ff43",
        "module": "#adc700",
        "tag": "#adc700",
        "jsxTag": "#adc700",
        "tagAttribute": "#89c2ea",
        "tagAttributeValue": "#44cec4",
        "boolean": "#eca7c8",
        "decorator": "#adc700",
        "label": "#89c2ea",
        "regexp": "#44cec4"
      }
    },
    "charts": {
      "series": [
        "#6c71c4",
        "#2aa198",
        "#859900",
        "#b58900",
        "#e56663"
      ]
    },
    "chat": {
      "background": "#002b36",
      "userMessage": "#d2d8d8",
      "userMessageBackground": "#26464e",
      "assistantMessage": "#b4bdbd",
      "assistantMessageBackground": "#1a3d46",
      "timestamp": "#afbec1",
      "divider": "#456066",
      "typing": "#afbec1"
    },
    "loading": {
      "spinner": "#6c71c4",
      "spinnerTrack": "#1a3d46",
      "skeleton": "#1a3d46",
      "shimmer": "#37545b"
    },
    "tools": {
      "background": "#1a3d46",
      "border": "#456066",
      "headerHover": "#36535b",
      "icon": "#9094d3",
      "title": "#93a1a1",
      "description": "#afbec1",
      "edit": {
        "added": "#859900",
        "addedBackground": "#85990024",
        "removed": "#e56663",
        "removedBackground": "#e5666324",
        "modified": "#2aa198",
        "modifiedBackground": "#2aa19824",
        "lineNumber": "#afbec1"
      }
    },
    "markdown": {
      "heading1": "#93a1a1",
      "heading2": "#93a1a1",
      "heading3": "#93a1a1",
      "heading4": "#93a1a1",
      "link": "#858ace",
      "linkHover": "#8589ce",
      "inlineCode": "#44cec4",
      "inlineCodeBackground": "#1a3d46",
      "blockquote": "#afbec1",
      "blockquoteBorder": "#456066",
      "listMarker": "#7075c5",
      "bold": "#93a1a1",
      "italic": "#93a1a1e6",
      "strikethrough": "#afbec1",
      "hr": "#456066"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#b94e46",
        "foreground": "#ffffff",
        "contrast": 4.95
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#ddb0a6",
        "foreground": "#000000",
        "contrast": 10.84
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#bc864d",
        "foreground": "#000000",
        "contrast": 6.66
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bdc258",
        "foreground": "#000000",
        "contrast": 11.02
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#cde1ab",
        "foreground": "#000000",
        "contrast": 14.95
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#5abf53",
        "foreground": "#000000",
        "contrast": 9.01
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#5fab6d",
        "foreground": "#000000",
        "contrast": 7.53
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#87d3bb",
        "foreground": "#000000",
        "contrast": 12.07
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#52aabd",
        "foreground": "#000000",
        "contrast": 7.84
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#487fb9",
        "foreground": "#000000",
        "contrast": 5.01
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#aeb7d3",
        "foreground": "#000000",
        "contrast": 10.51
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3e44b3",
        "foreground": "#ffffff",
        "contrast": 7.83
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8157a5",
        "foreground": "#ffffff",
        "contrast": 5.47
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#dba6dc",
        "foreground": "#000000",
        "contrast": 10.5
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#ba4a8a",
        "foreground": "#ffffff",
        "contrast": 4.74
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ad6474",
        "foreground": "#000000",
        "contrast": 4.85
      }
    ]
  }
}
